<template>
  <div>
    <CardWithImageAndButton
    title="Обезличивание данных"
    text="
    Технологическая платформа для надёжного и проверяемого обезличивания персональных данных с поддержкой отечественных СКЗИ и готовностью к использованию в ИИ-сценариях.
    <br /><br />
    Платформа базируется на научно обоснованных подходах к обезличиванию и реализует набор методов, обеспечивающих необратимость восстановления личности без ущерба для аналитической ценности данных.
    <br /><br />
    В рамках проекта разработаны собственные алгоритмы и SDK, которые можно внедрить в ИТ-ландшафт заказчика — как в централизованных системах, так и на уровне отдельных сервисов.
    <br /><br />
    Используемые технологии: Go, JavaScript.
    "
    :imagePath="require('../../assets/imgs/depersonalization.png')"
    imagePosition="right"
    :buttonIsVisible="false"
    />
    <List :items="listItems" title="Что мы сделали" theme="dark" />
  </div>
</template>

<script>
import { CardWithImageAndButton, List } from 'sputnik-ui/src/index';
export default {
  name: 'DepersonalizationPage',
  components: {
    CardWithImageAndButton,
    List
  },
  data() {
    return {
      listItems: [
        {text: "Разработаны методики обезличивания"},
        {text: "Разработаны алгоритмы и SDK для обезличивания"},
        {text: "Создан макет центра обезличивания ПДн"},
        {text: "Проведены испытания на обезличенных данных с применением ИИ"},
        {text: "Использованы отечественные СКЗИ для отдельных алгоритмов"},
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>
